const Section02 = ({
  contentsRef,
}: {
  contentsRef: React.RefObject<HTMLDivElement>;
}) => {
  return (
    <section className='section02 w-full' ref={contentsRef}>
      <div className='max-w-[1080px] px-[1%] pt-[100px] pb-[20px] mx-auto relative'>
        <img
          src='/imgs/section01_bg.png'
          alt='화살표배경'
          className='absolute w-[90%] object-contain left-0 right-0 mx-auto bottom-[50px]'
        />
        <h3 className='text-[#2F46B8] font-[600] mb-[12px]'>협회 소개</h3>
        <p className='max-w-[400px] text-[24px] leading-[38.4px] font-[600] whitespace-pre-line break-keep'>
          한국영업경제인협회는 건전한 영업 활동을 지원하기 위한 다양한 사업을
          전개합니다.
        </p>
        <p className='max-w-[780px] text-[16px] leading-[25.6px] font-[500] mt-[20px] whitespace-pre-line break-keep tracking-[-0.025em]'>
          영업 일선에서의 오랜 경험과 노하우를 바탕으로 협회 회원들이 최대한
          많은 혜택을 누릴 수 있는 시스템을 연구 중에 있습니다. 아울러 본
          협회만이 수행할 수 있는 4단계의 핵심 과제를 통해 시스템이 정착될 수
          있는 기틀을 마련하고자 합니다.
          <br />
          궁극적으로 영업·경제활동에 종사하는 전 국민의 권익을 보호하고 이들을
          육성할 수 있는 생태계를 만드는 것을 목표로 합니다.
        </p>
        <div className='w-full mt-[60px]'>
          <ul className='w-full flex justify-start items-end gap-[12px]'>
            <li className='text-white flex justify-start items-end px-[24px] py-[40px] relative w-[calc((100%-48px)/4)] rounded-[10px] overflow-hidden min-h-[160px]'>
              <img
                src='/imgs/section01_item_bg01.webp'
                alt=''
                className='w-full h-full absolute left-0 top-0'
              />
              <div className='relative flex flex-col justify-start items-start gap-[10px]'>
                <span className='text-[#222222] text-[14px] leading-[14px] font-[600] py-[4px] px-[8px] bg-white rounded-[8px]'>
                  01
                </span>
                <p className='max-w-[180px] text-[16px] leading-[24px] font-[600] whitespace-pre-line break-keep'>
                  회원 상호 간의 정보 교류 및 유·무형의 상품 공유/중개
                </p>
              </div>
            </li>
            <li className='text-white flex justify-start items-end px-[24px] py-[40px] relative w-[calc((100%-48px)/4)] rounded-[10px] overflow-hidden min-h-[193px]'>
              <img
                src='/imgs/section01_item_bg02.webp'
                alt=''
                className='w-full h-full absolute left-0 top-0'
              />
              <div className='relative flex flex-col justify-start items-start gap-[10px]'>
                <span className='text-[#222222] text-[14px] leading-[14px] font-[600] py-[4px] px-[8px] bg-white rounded-[8px]'>
                  02
                </span>
                <p className='max-w-[180px] text-[16px] leading-[24px] font-[600] whitespace-pre-line break-keep'>
                  회원 권익 보호 활동 및 회원만의 혜택 확대
                </p>
              </div>
            </li>
            <li className='text-white flex justify-start items-end px-[24px] py-[40px] relative w-[calc((100%-48px)/4)] rounded-[10px] overflow-hidden bg-gradient-to-b from-[#00000000] to-[#00000099] min-h-[255px]'>
              <img
                src='/imgs/section01_item_bg03.webp'
                alt=''
                className='w-full h-full absolute left-0 top-0'
              />
              <div className='relative flex flex-col justify-start items-start gap-[10px]'>
                <span className='text-[#222222] text-[14px] leading-[14px] font-[600] py-[4px] px-[8px] bg-white rounded-[8px]'>
                  03
                </span>
                <p className='max-w-[180px] text-[16px] leading-[24px] font-[600] whitespace-pre-line break-keep'>
                  관련 분야 역량 강화 교육 및 유관 기관과의 협력 사업
                </p>
              </div>
            </li>
            <li className='text-white flex justify-start items-end px-[24px] py-[40px] relative w-[calc((100%-48px)/4)] rounded-[10px] overflow-hidden bg-gradient-to-b from-[#00000000] to-[#00000099] min-h-[300px]'>
              <img
                src='/imgs/section01_item_bg04.webp'
                alt=''
                className='w-full h-full absolute left-0 top-0'
              />
              <div className='relative flex flex-col justify-start items-start gap-[10px]'>
                <span className='text-[#222222] text-[14px] leading-[14px] font-[600] py-[4px] px-[8px] bg-white rounded-[8px]'>
                  04
                </span>
                <p className='max-w-[180px] text-[16px] leading-[24px] font-[600] whitespace-pre-line break-keep'>
                  건전한 생태계 구축으로
                  <br />
                  국가 경제 발전에 기여
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
export default Section02;
